export default __webpack_public_path__ + "static/media/kausi8-min.7c65d62b.jpg";